export const iconFontAwesomeAutomotiveCarTunnel = (
	<i className="fa-solid fa-car-tunnel"></i>
);
